import { render, staticRenderFns } from "./MatterTimeAllocationComponent.vue?vue&type=template&id=472e38ba&scoped=true"
import script from "./MatterTimeAllocationComponent.vue?vue&type=script&lang=js"
export * from "./MatterTimeAllocationComponent.vue?vue&type=script&lang=js"
import style0 from "./MatterTimeAllocationComponent.vue?vue&type=style&index=0&id=472e38ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472e38ba",
  null
  
)

export default component.exports